import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated, selectUser } from '../stores/authStore'

/**
 * Wraps all protected routes. Rules:
 * - Not authenticated → /login
 * - Authenticated + not onboarded → /onboarding
 * - Authenticated + onboarded → render Outlet
 */
export default function ProtectedRoute() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const user = useAuthStore(selectUser)

  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (user && !user.onboarding_completed) return <Navigate to="/onboarding" replace />

  return <Outlet />
}
